var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1844 -352)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 227",
    cx: 12,
    cy: 12,
    r: 11,
    transform: "translate(1844 352)",
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1025",
    d: "M1858.2 357.816a1.721 1.721 0 01-.532 1.294 1.761 1.761 0 01-1.265.513 1.739 1.739 0 01-1.274-.532 1.739 1.739 0 01-.529-1.275 1.728 1.728 0 01.532-1.265 1.739 1.739 0 011.274-.532 1.728 1.728 0 011.265.532 1.728 1.728 0 01.529 1.265zm1.321 10.821V371h-6.337v-2.363h1.563v-5.5h-1.563v-2.4H1858v7.9z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))));
}

export default SvgKpmgInfo;